import { render, staticRenderFns } from "./ImageZoomModal.vue?vue&type=template&id=d0d52182&scoped=true&"
import script from "./ImageZoomModal.vue?vue&type=script&lang=js&"
export * from "./ImageZoomModal.vue?vue&type=script&lang=js&"
import style0 from "./ImageZoomModal.vue?vue&type=style&index=0&id=d0d52182&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d52182",
  null
  
)

export default component.exports